import React from 'react';
import { TSHIRT_COLORS } from '../../../config/productImages';

const LIGHT_HEXES = ['#FFFFFF', '#B5B5B5', '#339966'];

export const ColorSelector = ({ color, isTransitioning, onColorChange }) => (
  <div className="w-full max-w-md mt-4 sm:mt-6">
    <h3 className="text-xs font-bold text-gray-600 uppercase tracking-wide mb-2 sm:mb-3">Product Color</h3>
    <div className="flex flex-wrap gap-1.5 sm:gap-2">
      {TSHIRT_COLORS.map((c) => (
        <button
          key={c.id}
          data-testid={`color-${c.id}`}
          onClick={() => onColorChange(c)}
          disabled={isTransitioning}
          title={c.name}
          className={`group relative w-8 h-8 sm:w-9 sm:h-9 rounded-lg transition-all duration-200 ${
            color === c.hex
              ? 'ring-2 ring-primary ring-offset-1 sm:ring-offset-2 scale-110'
              : 'hover:scale-105 border border-gray-200'
          } ${isTransitioning ? 'opacity-50 cursor-not-allowed' : ''}`}
          style={{
            backgroundColor: c.hex,
            borderColor: c.hex === '#FFFFFF' ? '#e5e7eb' : 'transparent',
          }}
        >
          {color === c.hex && (
            <div className="absolute inset-0 flex items-center justify-center">
              <svg
                className="w-3 h-3 sm:w-4 sm:h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke={LIGHT_HEXES.includes(c.hex) ? '#000' : '#fff'}
                strokeWidth={3}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          )}
        </button>
      ))}
    </div>
  </div>
);

export default ColorSelector;
